import { isJsonResponse } from '../constants/helpers/utils';

export async function handleResponseError(response: Response, returnAll: boolean = false) {
  if (isJsonResponse(response)) {
    const jsonData = await response.json();

    if (returnAll) {
      throw jsonData;
    }

    throw jsonData.code;
  } else {
    throw await response.text();
  }
}
